import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import moment from 'moment'
import { fetchApi } from '../../services/fetch'
import { printLogs } from '../../utils'
import { endPoints } from '../../services/endPoints'

export const getUsersListAction = createAsyncThunk('users/getUsers',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.usersList,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const updateUserAction = createAsyncThunk('users/updateUser',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.updateUser,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })
